const translations = {
    zipCodeFieldLabel: 'Zip Code'
};

export default translations;
